<template>
    <form>
        <div class="card">
            <div class="card-header">
                {{ $t('filter.title') }}
                <button type="button" @click="hideSearchFormClickHandler" class="float-right btn btn-sm btn-secondary">
                    <font-awesome-icon :icon="compressIcon"></font-awesome-icon>        
                </button>
            </div>

            <div v-if="searchFormVisible" class="card-body searchFilterForm">
                
                <!-- ### FORM START ### -->
                <b-form @submit="submitFilter">
                    <div class="form-group row" v-if="filterForm.id">
                        <label class="col-md-2 col-form-label">{{ $t('filter.documentId') }}</label>
                        <div class="col-md-10">
                            <b-form-input
                                :value="filterForm.id"
                                disabled="disabled">
                            </b-form-input>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-2 col-form-label">{{ $t('filter.touroperator') }}</label>
                        <div class="col-md-10">
                            <vue-bootstrap-typeahead
                                ref="typeahead"
                                :data="touroperators"
                                @hit="TouroperatorData = $event.value"
                                :serializer="item => item.name"
                                v-model="TouroperatorData"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="editField-DateFrom" class="col-md-2 col-form-label">{{ $t('filter.validFrom') }}</label>
                        <div class="col-md-10">
                            <b-form-datepicker
                                v-model="filterForm.valid_from"
                                id="editField-DateFrom"
                                class="mb-2">
                            </b-form-datepicker>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-2">{{ $t('filter.active') }}</div>
                        <div class="col-md-10">
                                <b-form-radio-group
                                    v-model="filterForm.active"
                                    :options="activeFilterOptions"
                                    buttons
                                    button-variant="outline-secondary"
                                    >
                                </b-form-radio-group>                                    
                        </div>
                    </div>
                    
                </b-form>
                <!-- ### FORM END ### -->
            </div>
            <div v-if="searchFormVisible" class="card-footer searchFilterForm">
                <div class="float-right form-group bottom">
                    <button type="button" @click="resetFilter" class="btn-sm btn-secondary">{{ $t('filter.reset') }}</button>
                    <button type="button" @click="submitFilter" class="btn-sm btn-primary">{{ $t('filter.submit') }}</button>
                </div>
            </div>

        </div>
    </form>
</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

export default {
    components: {
        VueBootstrapTypeahead
    },
    data() {
        return {
            searchFormVisible: true,
            filterForm: {
                active: ''
            },
            TouroperatorData: '',
            touroperators: require("@/config/touroperators.json"),
            activeFilterOptions: [
                { text: this.$t('filter.all'), value: ''},
                { text: this.$t('filter.true'), value: true },
                { text: this.$t('filter.false'), value: false }
            ]
        };
    },
    computed: {
        compressIcon() {
            return this.searchFormVisible ? 'compress-alt' : 'expand-alt' ;
        }
    },
    methods: {
        hideSearchFormClickHandler() {
            this.searchFormVisible = !this.searchFormVisible;
        },
        resetFilter(e) {
            this.filterForm = {
                active: ''
            };
            this.$refs.typeahead.inputValue = '';
            this.submitFilter(e);
        },
        submitFilter(e) {
            e.preventDefault();
            this.$emit('setFilter', this.filterForm);
        }
    },
    watch: {
        TouroperatorData: {
            handler: function(data){
                this.filterForm.to_code = data;
            }
        },
    }
}

</script>

<style scoped lang="scss">
    .card-footer {
        button {
            margin-left: 1em;
        }
        .form-group {
            margin-bottom: 0;
        }
    }
</style>